var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgSold = function SvgSold(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 19.85,
    height: 20,
    viewBox: "0 0 19.85 20"
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "a",
    d: "M0 0h20v20H0z"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    fill: "#fff"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#a"
  })), /*#__PURE__*/React.createElement("g", {
    fillRule: "nonzero",
    mask: "url(#b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.887 19.735H2.486a1.051 1.051 0 0 1-1.048-1.047c0-.575.472-1.047 1.048-1.047h9.413c.575 0 1.047.472 1.047 1.047 0 .564-.483 1.047-1.059 1.047z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M5.593 15.49a2 2 0 0 1-1.427-.588l-3.58-3.579A2.001 2.001 0 0 1 0 9.896c0-.54.207-1.047.587-1.426l.725-.725a2 2 0 0 1 1.427-.587c.54 0 1.047.207 1.427.587l3.579 3.578a2.028 2.028 0 0 1 0 2.854l-.725.725c-.38.38-.887.587-1.427.587zM2.727 8.986a.242.242 0 0 0-.126.046l-.725.725a.18.18 0 0 0 0 .254l3.579 3.578a.158.158 0 0 0 .126.046c.023 0 .08-.011.127-.046l.725-.725a.18.18 0 0 0 0-.253l-3.58-3.567a.16.16 0 0 0-.126-.058zm10.012-.656a2.012 2.012 0 0 1-1.427-.586l-3.579-3.58a2.001 2.001 0 0 1-.587-1.426 2 2 0 0 1 .587-1.427l.725-.725C8.838.207 9.344 0 9.885 0c.54 0 1.047.207 1.427.587l3.579 3.579a2 2 0 0 1 .587 1.427c0 .54-.208 1.047-.587 1.427l-.725.725a2.02 2.02 0 0 1-1.427.586zm-2.843-6.5a.173.173 0 0 0-.126.046l-.725.725c-.046.046-.046.092-.046.126 0 .023.011.08.046.127l3.579 3.579a.18.18 0 0 0 .253 0l.725-.725c.046-.046.046-.092.046-.127a.242.242 0 0 0-.046-.126l-3.579-3.58a.241.241 0 0 0-.127-.045z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "m2.573 7.445 4.882-4.883L8.96 4.068 4.078 8.95 2.573 7.445zm3.982 3.997 4.882-4.882 1.505 1.506-4.882 4.882-1.505-1.506z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#191919",
    d: "M17.376 20a2.31 2.31 0 0 1-1.634-.679l-8.25-8.25 3.417-3.419 8.262 8.263c.438.437.68 1.013.68 1.634s-.242 1.197-.68 1.634l-.16.161a2.387 2.387 0 0 1-1.635.656zm-7.284-8.93 6.95 6.95a.459.459 0 0 0 .657 0l.16-.16a.459.459 0 0 0 0-.656l-6.95-6.95-.817.816z"
  })))));
};
export default SvgSold;